const IDB_NAME = 'Context360_GlobalFeed_v1';
const STORE_NAME = 'Feeds';

const openDB = () => {
    return new Promise((resolve, reject) => {
        const req = indexedDB.open(IDB_NAME, 1);
        req.onupgradeneeded = e => { 
            if (!e.target.result.objectStoreNames.contains(STORE_NAME)) {
                e.target.result.createObjectStore(STORE_NAME); 
            }
        };
        req.onsuccess = () => resolve(req.result);
        req.onerror = () => reject(req.error);
    });
};

export async function loadGlobal() {
    try {
        const db = await openDB();
        return new Promise(resolve => {
            const tx = db.transaction(STORE_NAME, 'readonly');
            const req = tx.objectStore(STORE_NAME).get('mainState');
            req.onsuccess = () => resolve(req.result || { posts: [], tokens: {}, lastSync: {} });
            req.onerror = () => resolve({ posts: [], tokens: {}, lastSync: {} });
        });
    } catch(e) { 
        return { posts: [], tokens: {}, lastSync: {} }; 
    }
}

export async function saveGlobal(localPosts, localToken, localSync) {
    try {
        const db = await openDB();
        let globalState = await loadGlobal();

        // Merge posts without duplicates
        const postMap = new Map();
        globalState.posts.forEach(p => postMap.set(p.id, p));
        localPosts.forEach(p => postMap.set(p.id, p));
        globalState.posts = Array.from(postMap.values());

        globalState.tokens["ALL_POSTS"] = localToken;
        globalState.lastSync["ALL_POSTS"] = localSync;

        return new Promise(resolve => {
            const tx = db.transaction(STORE_NAME, 'readwrite');
            tx.objectStore(STORE_NAME).put(globalState, 'mainState');
            tx.oncomplete = () => resolve(true);
        });
    } catch(e) { 
        console.warn("IDB Merge Fail", e); 
    }
}